// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
import isDev from 'utils/env'

export enum TaskType {
  Passive,
  Active
}

export enum QuotaCycle {
  UnKnown = 0,
  CalendarMonth,
  PickedDay
}

export enum OnlineStatus {
  Offline,
  Online
}

export enum DeviceStatus {
  Healthy,
  Issue,
  Damaged
}

export enum DeviceType {
  TwoW,
  FourW,
  Lite360Master,
  Lite360Slave,
  //Lite360Camera
}

export enum BatteryLevel {
  UnKnown = -1,
  GT50,
  GT20_LT50,
  LT20,
  LT10
}

export enum DataUsageLevel {
  Normal,
  BeyondLimit,
  BeyondHardLimit
}

export enum Environments {
  Public = 2,
  Staging = 1,
  Private = 1
}

const uploadUrlOfStaging = 'http://staging.kartaview.org'
const oldUploadUrlOfPrivate = 'https://grab.openstreetcam.org'
const uploadUrlOfPrivate = 'https://organizations.kartaview.org'
const uploadUrlOfPublic = 'https://kartaview.org'

export const EnvironmentsOptions = isDev()
  ? [
      { label: 'Public', value: Environments.Public, uploadUrl: uploadUrlOfPublic},
      { label: 'Staging', value: Environments.Staging, uploadUrl: uploadUrlOfStaging }
    ]
  : [
      { label: 'Public', value: Environments.Public, uploadUrl: uploadUrlOfPublic },
      { label: 'Private', value: Environments.Private, uploadUrl: uploadUrlOfPrivate }
    ]

export const OldEnvironmentsOptions = isDev()
? [
    { label: 'Public', value: Environments.Public, uploadUrl: uploadUrlOfPublic},
    { label: 'Staging', value: Environments.Staging, uploadUrl: uploadUrlOfStaging }
  ]
: [
    { label: 'Public', value: Environments.Public, uploadUrl: uploadUrlOfPublic },
    { label: 'Private', value: Environments.Private, uploadUrl: oldUploadUrlOfPrivate }
  ]

export type DeviceID = string;
export type DeviceGroupID = number

export interface IDevice {
  battery?: number
  cityID: number
  deviceID: string
  distCoveredPerday: number
  distanceCovered: number
  totalDistanceCovered: number
  errorsLast7Days: number
  onlinePeriod: number
  onlinePeriodPerday: number
  quotaUsage: number
  quotaUsagePercent: number
  quotaUsageLevel: number
  testMode: boolean
  totalOnlinePeriod: number
  uniqueDistPerday: number
  longitude: number
  latitude: number
  settingID: number
  driverID: string
  onlineStatus: OnlineStatus
  status: DeviceStatus
  deviceType: DeviceType
  taskType: TaskType
  firmwareVersion: string
  onlineTime: number
  settingSynced: boolean
  billingCycleStart: number
  environment: Environments,
  aiPrivacy: boolean
  groupID?: DeviceGroupID;
  imageUploadingStatus: number
  workStatus: number
  totalImageCount: number
  freeStorage: number
}


export enum Lite360GroupDeviceMemberRole {
  Master,
  Slaver
}

export enum Lite360GroupDeviceMemberDirection {
  Front,
  Right,
  Back,
  Left,
}

export interface ILite360GroupDeviceMember {
  role: Lite360GroupDeviceMemberRole
  direction: Lite360GroupDeviceMemberDirection
  deviceID: DeviceID

}

export interface IDeviceWithLiteGroupInfo extends  IDevice, ILite360GroupDeviceMember{

}

export const HealthOptions = [
  {label:'Health',value: DeviceStatus.Healthy},
  {label:'Issue',value: DeviceStatus.Issue},
  {label:'All',value: '-1'},

]

export const DeviceTypeOptions = [
  {label:'2W',value: DeviceType.TwoW},
  {label:'4W',value: DeviceType.FourW},
  {label:'360Lite',value: DeviceType.Lite360Master},
  {label:'All',value: '-1'},
]

export const StatusOptions = [
  {label:'Online',value: OnlineStatus.Online},
  {label:'Offline',value: OnlineStatus.Offline},
  {label:'All',value: '-1'},
]



export interface ILite360Group {
  groupId: DeviceGroupID;
  status: number;
  devices: ILite360GroupDeviceMember[]
}

export const LiteGroupDeviceDirectionNames = {
  [Lite360GroupDeviceMemberDirection.Front]: "Front",
  [Lite360GroupDeviceMemberDirection.Back]: "Back",
  [Lite360GroupDeviceMemberDirection.Left]: "Left",
  [Lite360GroupDeviceMemberDirection.Right]: "Right"
};


export enum CameraDirectoryAction {
  ViewDetails,
  ChangeSettings,
  ViewTracks,
  CreateTask
}

// all storage of camera
export  const  CameraStorage = 64 * 1024

